import i18next from "i18next";

/**
 * Which language the interface is in, and the locale that follows from it.
 *
 * Apart from `i18n.ts` because that file sets i18next up when it is imported,
 * and the places that need a locale — a date, a decimal, a country's name —
 * are small pure helpers that unit tests import on their own. They ask the
 * i18next singleton what it is set to and nothing more, so before it has been
 * set up they get Swedish, the interface's own language.
 */
export type Language = "sv" | "en";

export function currentLanguage(): Language {
  return i18next.language === "en" ? "en" : "sv";
}

/**
 * The locale dates, numbers and country names are written in.
 *
 * British rather than American English for the English interface: day before
 * month, which is the order a Swedish reader already writes a date in, and the
 * twenty-four-hour clock.
 *
 * **Sorting is not part of it.** The names in a cellar — producers, cabinets,
 * shelves, areas — are what they are whichever language the screen is in, and
 * they stay in Swedish collation; only lists of things the interface itself
 * names, the countries, follow the language.
 */
export function locale(): string {
  return currentLanguage() === "en" ? "en-GB" : "sv-SE";
}
